import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { connect } from 'react-redux';
import { toggleDrawer as toggleDrawerAction } from '../state/app';
import { withPrefix } from "gatsby-link";

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'

import '../utils/cmwf.scss'

const Layout = ({ children, data, isDrawerOpen, location, toggleDrawer }) => {
  const isHomepage = location.pathname === withPrefix("/");
  return (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: data.site.siteMetadata.siteDescription },
      ]}
      htmlAttributes={{
        class: isDrawerOpen ? 'menu-open' :  'menu-closed',
      }}
      link={[
        { rel: 'icon', type: 'image/png', href: withPrefix("/favicon.ico") }
      ]}
      >
      <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
      <meta property="og:title" content={data.site.siteMetadata.title}/>
      <meta property="og:description" content={data.site.siteMetadata.siteDescription}/>
      <meta property="og:url" content={`${data.site.siteMetadata.siteUrl}`}/>
      <meta property="og:image" content={`${data.site.siteMetadata.siteUrl}/2018-state-health-system-scorecard-share.png`}/>
      <meta property="og:image:url" content={`${data.site.siteMetadata.siteUrl}/2018-state-health-system-scorecard-share.png`}/>
      <meta property="og:image:type" content="image/png"/>
      <meta property="og:image:width" content="1200"/>
      <meta property="og:image:height" content="630"/>
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:description" content={data.site.siteMetadata.siteDescription}/>
      <meta name="twitter:title" content={data.site.siteMetadata.title}/>
      <meta name="twitter:site" content="@commonwealthfnd"/>
      <meta name="twitter:image" content={`${data.site.siteMetadata.siteUrl}/2018-state-health-system-scorecard-share.png`}/>
    </Helmet>
    <Header
      siteYear={data.site.siteMetadata.year}
      siteSubtitle={data.site.siteMetadata.subtitle}
      site={data.site.siteMetadata}
      isHome={ isHomepage }
      themes={ data.allThemesJson.edges}
      states={ data.allStatesJson.edges}
      social={ data.allSocialJson.edges}
      location={ location } />
    <div className="l-container">
      {children()}
    </div>
    <Footer />
  </div>
)
};

Layout.propTypes = {
  children: PropTypes.func,
}

export default connect(
  state => ({ isDrawerOpen: state.app.isDrawerOpen }),
  dispatch => ({ toggleDrawer: open => dispatch(toggleDrawerAction(open)) }),
)(Layout);

export const query = graphql`
  query DefaultLayoutQuery {
    site {
      pathPrefix
      siteMetadata {
        title
        year
        subtitle
        siteUrl
        siteDescription
      }
    }
    allThemesJson {
      edges {
        node {
          theme_id
          title
          path
          stat {
            suffix
            number
            text
          }
        }
      }
    }
    allStatesJson {
      edges {
        node {
          id
          title
          url
          ranking
        }
      }
    }
    allSocialJson {
      edges {
        node {
          page_id
          path
          title
          share_path
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js